export class CategorySequenceEntity {
    CategoryId: string | null = null;
    Sequence: number | null = null;
  }
  